/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  autocomplete: {
    [theme.breakpoints.down('md')]: {
      width: '16rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '27rem',
    },
  },
}));

const AutoCompleteWidget = (props) => {
  const {
    id,
    options,
    value,
    inputValue,
    setValue,
    setInputValue,
    onGetLabel,
    schema = {},
    uiSchema = {},
    label,
  } = props;
  const { t } = useTranslation();

  const displayLabel = label || (uiSchema?.config?.title && t(uiSchema?.config?.title)) || schema.title;
  const classes = useStyles();

  return (
    <Autocomplete
      id={`autocomplete-${id}`}
      disableClearable
      options={options}
      getOptionLabel={onGetLabel}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={params => (
        <TextField
          id={id}
          label={displayLabel}
          className={classes.autocomplete}
          value={value || value === 0 ? value : ''}
          InputProps={{
            'aria-label': label || schema.title,
            readOnly: schema?.config?.type === 'read-only',
          }}
          {...params}
        />
      )}
    />
  );
};

export default AutoCompleteWidget;
